import { getActiveRentalPayment } from "../../../data/loca/rentals";
import {
    useLoaderData
} from "react-router-dom";


export async function loader({ params }) {
    const payment = await getActiveRentalPayment(params.rentalId);
    var error = payment.message;

    if (payment.status === 200) {
        let link = `/paiement/${payment.message}/${params.rentalId}`

        window.location.href = link;
        return { error };
    }
    else {
        return { error };

    }

}


export default function SwitchPayment() {
    const { error } = useLoaderData();
    return (<></>)

}